export const selectStudentDg = `
<div class="screen-overlay studentSelect-overlay">
	<div class="studentSelect">
		<div class="ss-title">Select or Add Your Name</div>
		<div class="ss-description">Add your name to save your scores on this
			computer. Student names are not uploaded to a server.
		</div>
		<div class="ss-studentList">
		</div>
		<div class="ss-buttons">
			<div class="ss-addStudentBtnDiv m-bigBtnDiv">
				<button class="ss-addStudentBtn">Add Name</button>
			</div>
			<div class="ss-forTeachersBtnDiv m-bigBtnDiv">
				<button class="ss-teachersBtn">Teachers...</button>
			</div>
		</div>
	</div>
</div>
`;

export const selectStudentListItem = `
<div class="ss-studentListItem">
	<div class="ss-listItem-name"></div>
	<div class="ss-listItem-team"></div>
</div>
`;